import EfImg from 'elem/ui/ef-img';
import EfSpec from 'elem/ui/ef-spec';
import { useState } from 'react';
import { Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('dp3.landing.EU7');
    const [swiper, setSwiper] = useState(null);
    const [active, setActive] = useState(0);
    const imgArr = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297091066/%E5%BE%AE%E9%80%86%E5%9B%BE2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724297091066/%E5%BE%AE%E9%80%86%E5%9B%BE2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725179314744/h5-energy-llocation-1.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297091635/%E5%BE%AE%E9%80%86%E5%9B%BE3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724297091635/%E5%BE%AE%E9%80%86%E5%9B%BE3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725179314556/h5-energy-llocation-3.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297090801/%E5%BE%AE%E9%80%86%E5%9B%BE4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724297090801/%E5%BE%AE%E9%80%86%E5%9B%BE4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725179314962/h5-energy-llocation-2.jpg',
        },
    ];

    return (
        <div className={`${css['thecomp']} GtmModuleData-section`} data-section-id={'dp3-EU7'} data-section-title={t(`title${active + 1}`)}>
            <EfSpec className="spec-x" />
            <p className="dp3-title title">{t(`title${active + 1}`)}</p>
            <p className="dp3-desc desc">{t(`desc${active + 1}`)}</p>
            <Swiper
                className={`swiper-box ${imgArr?.length === 1 ? 'single' : ''}`}
                modules={[Scrollbar, Pagination, Navigation]}
                navigation={imgArr?.length > 1}
                pagination={imgArr?.length > 1}
                loop={imgArr?.length > 1}
                spaceBetween={0}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
                onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
                onSlideChange={(swiper) => setActive(swiper.realIndex)}
            >
                {imgArr?.map((img: any, k: number) => {
                    return (
                        <SwiperSlide className={`swiper-item`} key={k}>
                            <EfImg pc={img?.pc} pad={img?.pad} h5={img?.h5} />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
